import { Component, Input, OnInit } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { DONOR_COLORS } from '../../../model/Colors';

@Component({
  selector: 'rc-bar-chart',
  standalone: true,
  imports: [ ChartModule],
  templateUrl: './generic-bar-chart.component.html',
  styleUrl: './generic-bar-chart.component.scss'
})
export class GenericBarChartComponent implements OnInit {

    @Input() labels:Array<string> = [];
    @Input() colors:Array<string> = [DONOR_COLORS[0]];
    @Input() data:Array<number> = [];   
    
    chartData:any = {
            labels: ['Q1', 'Q2', 'Q3', 'Q4'],
            datasets: [
                {
                    label: 'Sales',
                    data: [540, 325, 702, 620],
                    backgroundColor: ['#CB4566', '#DE8348', '#59B264', '#6B524D'],
                    borderColor: ['#990026', '#993C00', '#1B6425', '#382724'],
                    borderWidth: 1
                }
            ]
        };


    
    ngOnInit() {
        this.chartData = {
                labels: [...this.labels],
                datasets: [
                    {
                        skipNull: true,
                        label: 'Total',
                        data: [...this.data.map(i => parseInt(i.toString()))],
                        backgroundColor: this.colors,
                        borderColor: ['#ffffff'],
                        borderWidth: 1
                    }
                ]
            };
    }

    chartOptions:any = {
                plugins: {
                    legend: {
                        display: false,
                        labels: {
                            color: "white"
                        }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            color: "#1F1513"
                        },
                        grid: {
                            color: "#D6C4C1",
                            drawBorder: false
                        }
                    },
                    x: {
                        ticks: {
                            color: "#1F1513"
                        },
                        grid: {
                            color: "#D6C4C1",
                            drawBorder: false
                        }
                    }
                }
        };
}
